import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Flex from "components/grid/Flex";

export const TagsRenderer = ({ config, rule, idx, handleUpdateRule, disabled }) => {
    const valueKey = rule.properties.value.type === "tags" ? "value" : "tagsValue";
    const tagValuesKey = config.values ? "values" : "tagsValues";
    const activeTags = rule.properties.value[valueKey];
    const { t } = useTranslation();

    return (
        <Flex item container alignItems={"center"} wrap>
            {config[tagValuesKey].map((tag) => (
                <Button
                    disabled={disabled}
                    key={tag.value}
                    onClick={() => {
                        handleUpdateRule(idx, {
                            ...rule.properties,
                            value: {
                                ...rule.properties.value,
                                [valueKey]: activeTags.has(tag.value) ? activeTags.delete(tag.value) : activeTags.add(tag.value),
                            }
                        });
                    }}
                    style={{ margin: 4}}
                    disableElevation
                    disableRipple
                    size="small"
                    color={activeTags.has(tag.value) ? "primary" : "default"}
                    variant="contained"
                >
                    {t(tag.label)}
                </Button>
            ))}
        </Flex>
    );
};
